import { en } from "./en";
import type { TranslationFunction } from "./types";

const INTERPOLATION = /{{\s*(\w+)\s*}}/g;

// Built-in English translator, used when the app injects none.
export const translate: TranslationFunction = (key, options) => {
  const value = key
    .split(".")
    .reduce<unknown>(
      (node, part) => (node as Record<string, unknown> | undefined)?.[part],
      en,
    );

  if (typeof value !== "string") return key;

  return value.replace(INTERPOLATION, (match, name: string) =>
    options && name in options ? String(options[name]) : match,
  );
};
